import React from "react";
import {Badge, Box, Button, Tooltip} from "@mui/material";
import NotificationsIcon from "@mui/icons-material/Notifications";

import {useShiftUpdateCount} from "../../hooks/useShiftUpdateCount";

export default function DataUpdateCountBadge() {

    const iconButtonStyle = {
        margin: '0.1rem',
        minHeight: '2rem',
        minWidth: '0',
        padding: '0 0.5rem',
        '& .MuiButton-endIcon': {margin: 0}
    };

    const {updatedShiftCount, resetDataUpdateCount} = useShiftUpdateCount();

    return <>
        <Tooltip title="Clear notifications">
            <Box marginRight={'0.5rem'}>
                <Badge badgeContent={updatedShiftCount} color="error" overlap="circular">
                    <Button variant='contained' size='small' sx={iconButtonStyle} onClick={resetDataUpdateCount} endIcon={<NotificationsIcon/>}/>
                </Badge>
            </Box>
        </Tooltip>
    </>;
}